// extracted by css-extract-rspack-plugin
export default {"wrapper":"FsaEseaeUEB3gkrG","pkd_header":"KW_o2vfBdwS18bug","pkd_title":"v6i3Rgj6jtowJG4q","item":"C80drCnh1gZC3Z9d","folder_wrapper":"rKrV2VluU0Qh5xJg"};